import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyHero from "./sections/PrivacyPolicyHero";
import PolicySections from "./sections/PolicySections";
import RegulatoryDisclosure from "./sections/RegulatoryDisclosure";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyHero />
      <PolicySections />
      <RegulatoryDisclosure />
      <Footer />
    </div>;
}